<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">Cargas com erros:</h5>
  </div>
  <div class="modal-body">
    <div class="table-container">
      <carga-fundo-error
        *ngIf="loadTypesId === 1"
        [result]="result"
      ></carga-fundo-error>
      <carga-gestor-error
        *ngIf="loadTypesId === 2"
        [result]="result"
      ></carga-gestor-error>
      <carga-error *ngIf="loadTypesId === 3" [result]="result"></carga-error>
      <fundo-inv-error
        *ngIf="loadTypesId === 4"
        [result]="result"
      ></fundo-inv-error>
      <carga-lastro-error
        *ngIf="loadTypesId === 6"
        [result]="result"
      ></carga-lastro-error>
    </div>
  </div>
</div>
